import {Links} from "../features/links/LinksPage"

export default Links.Page